import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CommonModule, DatePipe} from '@angular/common';
import {PageHomeComponent} from './home';
import {SystemAccessReportPageComponent} from './system-access-report';
import {Framework} from '../framework/framework.module';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {SystemsPageComponent} from './systems';
import {PageConfigComponent} from './config';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {AnomaliesPageComponent} from './anomalies';
import {SODCheckerPageComponent} from './sod-checker';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import {SorUserMappingHomeComponent} from './sor-user-mapping';
import {SystemRolesPageComponent} from './system-roles';
import {ApproverOverridesPageComponent} from './approver-overrides';
import {ReportBrowserPageComponent} from './report-browser';
import {SODClashesComponent} from './sod-clashes';
import {ReassignReportsComponent} from './reassign-reports';
import {AppUser} from '../framework/AppUser';
import {MyOktaAuthGuard} from '../my-okta-auth-guard';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {ReportPageComponent} from './report';
import {CheckApproversAccessPageComponent} from './check-approvers-access';
import {PageQARReportChasingComponent} from './qar-report-chasing';
import {ReportRejectedUsersPageComponent} from './report-rejected-users';
import {ApprovalRequestsPageComponent} from './approval-requests';
import {ApprovalRequestPageComponent} from './approval-request';
import {HelpPageComponent} from './help';
import {BlacklistPageComponent} from './backlist';
import {PageAuditLogComponent} from './audit-log';
import {PageUsersComponent} from './users';
import {UserRolesAutoRecPageComponent} from './user-roles-auto-rec';
import {SorUserInactiveHomeComponent} from './sor-user-inactive';

const routes: Routes = [
	{
		path: 'tools/anomalies',
		component: AnomaliesPageComponent,
		canActivate: [MyOktaAuthGuard],
		data: {right: ['ACCESS_ANOMALIES_PAGE']}
	},
	{
		path: 'config/approver-overrides',
		component: ApproverOverridesPageComponent,
		data: {right: ['ACCESS_APPROVER_OVERRIDE']}
	},
	{
		path: 'config',
		component: PageConfigComponent,
		data: {right: ['ACCESS_CONFIG']}
	},
	{
		path: 'tools/reassign-reports',
		component: ReassignReportsComponent,
		data: {right: ['ACCESS_REASSIGN_REPORTS']}
	},
	{
		path: 'reports',
		component: ReportBrowserPageComponent,
		data: {right: ['ACCESS_REPORT_BROWSER']}
	},
	{
		path: 'reports/participation/:id',
		component: ReportPageComponent,
		data: {right: ['ACCESS_REPORT']}
	},
	{
		path: 'tools/sod-checker',
		component: SODCheckerPageComponent,
		canActivate: [MyOktaAuthGuard],
		data: {right: ['ACCESS_SOD_CHECKER']}
	},
	{
		path: 'tools/sod-clashes',
		component: SODClashesComponent,
		data: {right: ['ACCESS_SOD_CLASHES']}
	},
	{
		path: 'tools/approvers-access-check',
		component: CheckApproversAccessPageComponent,
		data: {right: ['ACCESS_CHECK_APPROVERS_ACCESS']}
	},
	{
		path: 'config/sod-roles',
		component: SystemRolesPageComponent,
		data: {right: ['ACCESS_ROLES']}
	},
	{
		path: 'config/sor-user-mappings',
		component: SorUserMappingHomeComponent,
		data: {right: ['ACCESS_SOR_USER_MAPPINGS']}
	},
	{
		path: 'reports/system-access',
		component: SystemAccessReportPageComponent,
		data: {right: ['ACCESS_SYSTEM_ACCESS_REPORT']}
	},
	{
		path: 'audit/logs',
		component: PageAuditLogComponent,
		data: {right: ['ACCESS_AUDIT_LOG_PAGE']}
	},
	{

		path: 'reports/chasing',
		component: PageQARReportChasingComponent,
		data: {right: ['ACCESS_REPORT_CHASING']}
	},
	{
		path: 'reports/rejected-users',
		component: ReportRejectedUsersPageComponent,
		data: {right: ['ACCESS_REPORT_REJECTED_USERS']}
	},
	{
		path: 'config/systems',
		component: SystemsPageComponent,
		data: {right: ['ACCESS_SYSTEMS_PAGE']}
	},
	{
		path: 'config/blacklist',
		component: BlacklistPageComponent,
		data: {right: ['ACCESS_BLACKLIST_PAGE']}
	},
	{
		path: 'approval-requests',
		component: ApprovalRequestsPageComponent,
		data: {right: ['ACCESS_APPROVAL_REQUESTS_PAGE']}
	},
	{
		path: 'approval-requests/:id',
		component: ApprovalRequestPageComponent,
		data: {right: false}
	},
	{
		path: 'help',
		component: HelpPageComponent,
		data: {right: false}
	},
	{
		path: 'tools/user-roles-auto-rec',
		component: UserRolesAutoRecPageComponent,
		data: {right: ['ACCESS_USER_ROLES_AUTO_REC_PAGE']}
	},
	{
		path: 'users',
		component: PageUsersComponent,
		data: {right: ['ACCESS_USER_ROLE_CHECKER_PAGE']}
	},
	{
		path: 'reports/inactive-users',
		component: SorUserInactiveHomeComponent,
		data: {right: ['ACCESS_INACTIVE_USERS']}
	},
	{
		path: '**',
		component: PageHomeComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PagesModuleRouting {
	public static routes = [];
}

PagesModuleRouting.routes = routes;

@NgModule({
	imports: [
		CommonModule,
		RouterModule, FormsModule, Framework, MatButtonModule, MatToolbarModule, MatExpansionModule,
		MatFormFieldModule, MatCheckboxModule, MatInputModule, MatAutocompleteModule, ReactiveFormsModule,
		MatTooltipModule
	],
	exports: [PagesModuleRouting],
	declarations: [
		ApprovalRequestPageComponent,
		ApprovalRequestsPageComponent,
		PageHomeComponent,
		SystemAccessReportPageComponent,
		SystemsPageComponent,
		PageConfigComponent,
		AnomaliesPageComponent,
		SODCheckerPageComponent,
		SorUserMappingHomeComponent,
		SystemRolesPageComponent,
		ApproverOverridesPageComponent,
		ReportBrowserPageComponent,
		SODClashesComponent,
		ReassignReportsComponent,
		ReportPageComponent,
		CheckApproversAccessPageComponent,
		PageQARReportChasingComponent,
		ReportRejectedUsersPageComponent,
		BlacklistPageComponent,
		PageAuditLogComponent,
		PageUsersComponent,
		HelpPageComponent,
		UserRolesAutoRecPageComponent,
		SorUserInactiveHomeComponent
	],
	providers: [AppUser]
})
export class PagesModule {
}
